import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown, Button } from 'reactstrap';
import Avatar from '../common/Avatar';
import { getInitials, getAvatarColor } from '../../helpers/avatar.utils';


import { useTranslation, Trans } from 'react-i18next';

const ProfileDropdown = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const { t, i18n } = useTranslation();

  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <Dropdown
      nav
      inNavbar
      isOpen={dropdownOpen}
      toggle={toggle}
      onMouseOver={() => {
        let windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(true);
      }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        windowWidth > 992 && setDropdownOpen(false);
      }}
    >
      <DropdownToggle nav className="pr-0">
        <Avatar
          name={getInitials(user && user.prefijo)}
          isExact
          style={{ backgroundColor: getAvatarColor(user && user.prefijo) }}
        />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <div className="bg-white rounded-soft py-2">
        <DropdownItem tag={Link} to="/user/profile" >Perfil</DropdownItem>
          <hr className="navbar-vertical-hr my-2" />
          <DropdownItem tag={Link} to="#" onClick={() => i18n.changeLanguage("gl")} active={i18n.resolvedLanguage === "gl"}>{t("perfil.idioma_gl")}</DropdownItem>
          <DropdownItem tag={Link} to="#" onClick={() => i18n.changeLanguage("es")} active={i18n.resolvedLanguage === "es"}>{t("perfil.idioma_es")}</DropdownItem>
          <DropdownItem tag={Link} to="#" onClick={() => i18n.changeLanguage("en")} active={i18n.resolvedLanguage === "en"}>{t("perfil.idioma_en")}</DropdownItem>
          <DropdownItem tag={Link} to="#" onClick={() => i18n.changeLanguage("pt")} active={i18n.resolvedLanguage === "pt"}>{t("perfil.idioma_pt")}</DropdownItem>
          <hr className="navbar-vertical-hr my-2" />
          <DropdownItem tag={Link} to="/authentication/basic/logout">{t("perfil.cerrar_sesion")}</DropdownItem>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
